import styled, { css } from 'styled-components';
import { timingDefault } from '../../constants';
import { TypeStyle } from '../TypeStyle';
const hideVisually = css `
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;
export const Bullet = styled.div `
  background: white;
  border: 1.5px solid ${o => o.theme.color.deprecated.stone};
  border-radius: 50%;
  box-sizing: border-box;
  display: inline-block;
  height: 16px;
  margin-right: 15px;
  position: relative;
  top: 3px;
  transition: border-color ${timingDefault} ease-in-out;
  width: 16px;

  &:after {
    content: '';
    background: ${o => o.theme.color.deprecated.obsidian};
    border-radius: 50%;
    height: 6px;
    left: 50%;
    opacity: 0;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    transition: opacity ${timingDefault} ease-in-out;
    width: 6px;
  }
`;
export const Content = styled(TypeStyle.BodySmall) `
  display: inline-block;
  color: ${o => o.theme.color.deprecated.obsidianLighter};
`;
export const Label = styled.label `
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;

  > input {
    ${hideVisually}

    &:checked {
      ~ ${Bullet} {
        border-color: ${o => o.theme.color.deprecated.obsidian};

        &:after {
          opacity: 1;
        }
      }

      ~ ${Content} {
        color: ${o => o.theme.color.deprecated.obsidian};
      }
    }
  }
`;
//# sourceMappingURL=styles.js.map